// extracted by css-extract-rspack-plugin
export default {"tableHeaderContainer":"MilestonesTable_tableHeaderContainer__b0-Ed","menu":"MilestonesTable_menu__+OLTP","reward":"MilestonesTable_reward__f2qUj"};